/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".success-icon-circle[_ngcontent-%COMP%]{border-radius:24px;width:48px;height:48px;background:#32d3ca;display:flex;justify-content:center;align-items:center}.center[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}"];
export { styles as styles };
